import { useEffect, useState, useContext, useRef } from "react"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import RcmpCheckBox from "../../atoms/Checkbox"
import PurePlusIcon from "../../../assets/icons/PurePlusIcon"
import RcmpActivityIcon from "../../atoms/ActivityIcon"
import RcmpSingleAccordionIcon from "../../atoms/SingleAccordionIcon"
import RcmpModalAdd from "../../molecules/ModalAdd"
import styles from "./index.module.scss"
import RcmpLoading from "../../atoms/Loading"
import FieldsContext from "../../../contexts/Fields"
import {
  cDeadLineSlug,
  cResponsiblesSlug,
  cStatusSlug,
  dConclusionDateSlug,
  dCreationDateSlug,
} from "../../../constans/activity-slugs"
import PencilIcon from "../../../assets/icons/PencilIcon"
import BoardContext from "../../../contexts/Board"
import InfoIcon from "../../../assets/icons/InfoIcon"
import Input from "../../atoms/Input"

export default function RcmpModalCustomFields(props) {
  const {
    fnHandleCancel,
    bIsOpen,
    title,
    buttonCancelText,
    buttonSaveText,
    fnHandleConfirm,
    textHead,
    size,
    fnOpenModalNewCustomField,
    aCheckedFields,
    fnSetUpdateFields,
    bNewFormCriation = false,
    fnEditCustomField,
    bIsVisibleFieldsTable = false,
    bAddNewFields = true,
  } = props
  const aFieldsType = [
    { value: "default", label: intl.get("fields_type.default"), nPosition: 0 },
    { value: "text", label: intl.get("fields_type.text"), nPosition: 1 },
    { value: "number", label: intl.get("fields_type.number"), nPosition: 2 },
    { value: "selection", label: intl.get("fields_type.selection"), nPosition: 3 },
    { value: "date", label: intl.get("fields_type.date"), nPosition: 4 },
    { value: "peoples", label: intl.get("fields_type.people"), nPosition: 5 },
    { value: "calc", label: intl.get("fields_type.calc"), nPosition: 6 },
    { value: "range", label: intl.get("fields_type.range"), nPosition: 7 },
  ]
  const { fnGetFields, oAllFieldsRes, aAllFields } = useContext(FieldsContext)
  const { oCurrentBoard } = useContext(BoardContext)
  const parentRef = useRef(null)

  const [aFieldsByType, fnSetAFieldsByType] = useState([])
  const [aPreviousFields, fnSetAPreviousFields] = useState([])
  const [bSaveLoading, fnSetBSaveLoading] = useState(false)
  const [aFieldsByTypeCopy, fnSetAFieldsByTypeCopy] = useState([])
  const [cTermFilter, fnSetCTermFilter] = useState("")
  const [aCheckedFieldsList, fnSetACheckedFieldsList] = useState(() => aCheckedFields)

  useEffect(() => {
    if (!fnGetFields) return
    if(!aCheckedFields?.length) return
    if(oAllFieldsRes.loading) return
    ;(async () => {
      await fnGetFields()
      fnSetACheckedFieldsList(prev => {
        return aCheckedFields
      })
    })()
  }, [bIsOpen, aCheckedFields])

  const formatFieldsByType = () => {
     const aFormatedFieldsByType = aFieldsType?.map((cFieldType) => {
      let aFields = []
      aFields = aAllFields.filter(
        (oField) =>
          !oField?.opfd_bis_default &&
          oField?.opfd_ctype?.toLowerCase() === cFieldType.value,
      )
      if (cFieldType.value === "default") {
        aFields = aAllFields.filter((oField) => oField?.opfd_bis_default)
      }

      aFields = aFields?.map((oField) => {
        const oCheckedField = aCheckedFields?.find(
          (oCheckedField) => oCheckedField?.opfd_nid === oField?.opfd_nid,
        )

        if (oCheckedField) return { ...oCheckedField, ...oField }

        return oField
      })

      return {
        cFieldType,
        aFields,
      }
    })

    return aFormatedFieldsByType
  }

  useEffect(() => {
    if (!aAllFields?.length) return

    const aFormatedFieldsByType = formatFieldsByType()

    fnSetAFieldsByType(aFormatedFieldsByType)
    fnSetAFieldsByTypeCopy(aFormatedFieldsByType)
  }, [aCheckedFields, aAllFields])


  function formateVisibleFields(aData) {
    const aTypesWithFields = aData?.filter((oData) => oData?.aFields?.length > 0)

    let aPayload = []
    aTypesWithFields?.map((oTypeField) => {
      const aFields = oTypeField?.aFields?.map((oField) => ({
        ...oField,
        opfd_nid: oField?.opfd_nid,
        bis_visible: oField?.opvf_bis_visible,
      }))
      aPayload = [...aPayload, ...aFields]
    })
    return aPayload
  }
  // Handles the checkbox state change for fields
  function fnHandleCheckbox(index, oFieldType) {
    
    // Finds the index of the field type in the copy array
    const nFieldTypeIndex = aFieldsByTypeCopy.reduce((acc, oField, i) => {
      if (oField.cFieldType.value === oFieldType.cFieldType.value) {
        acc = i
      }
      
      return acc
    })
    // Finds the index of the checked field in the list
    const nCheckedFieldIndex = aCheckedFieldsList?.findIndex((field) => field.opfd_nid === oFieldType.aFields[index].opfd_nid)
  
    if(nCheckedFieldIndex === -1 ) {
      // Adds the new field to the checked fields list
      const oNewField = { ...oFieldType.aFields[index], opvf_bis_visible: true }
      
      fnSetACheckedFieldsList(prev => {
        return [...prev, oNewField]
      })
    } else if(nCheckedFieldIndex !== -1) {
      // Removes the field from the checked fields list
      const updateValue = aCheckedFieldsList.filter(
        (field) => field.opfd_nid !== oFieldType.aFields[index].opfd_nid
      )
      fnSetACheckedFieldsList(updateValue)
    }
    // Validation type of nTypeFieldIndex
    const nTypeFieldIndex = typeof nFieldTypeIndex === "number" ? nFieldTypeIndex : 0
    // Finds the index of the field in the copy array
    const nFieldIndex = aFieldsByTypeCopy[nTypeFieldIndex].aFields.findIndex((field) => field.opfd_nid === oFieldType.aFields[index].opfd_nid)
    fnSetAFieldsByTypeCopy((prev) => {
      // Creates a deep copy of the previous state
      const aFields = prev.map((fieldType, fieldTypeIndex) => {
          if (fieldTypeIndex === nTypeFieldIndex) {
              return {
                  ...fieldType,
                  aFields: fieldType.aFields.map((field, fieldIndex) => {
                      if (fieldIndex === nFieldIndex) {
                          return {
                              ...field,
                              opvf_bis_visible: nCheckedFieldIndex === -1 ? true : false,
                          };
                      }
                      return field;
                  })
              };
          }
          return fieldType;
      });
  
      return aFields;
    });

    // Updates the visibility of the fields in the main array
    const updateValue = aFieldsByType?.map((position) => {
      if (oFieldType?.aFields[index]?.opfd_nid === position?.aFields[index]?.opfd_nid) {
        const positionFields = position?.aFields.map((field) => {
          if (field?.opfd_nid === oFieldType?.aFields[index]?.opfd_nid) {
            field.opvf_bis_visible = !field.opvf_bis_visible
          }
          return field
        })
        return {
          ...position,
          fields: positionFields,
        }
      }

      return position
    })

    fnSetAFieldsByType(updateValue)
    fnSetAPreviousFields(updateValue)
  }

  async function fnHandleConfirmUpdateVisibilityFields() {
    fnSetBSaveLoading(true)
    const aPayload = formateVisibleFields(aFieldsByTypeCopy)
    await fnHandleConfirm(aPayload)
    fnSetBSaveLoading(false)
    fnSetUpdateFields?.(aPayload)
    fnHandleCancel()
  }

  function fnHandleStateAndCancel() {
    fnSetAFieldsByType([])
    fnSetAPreviousFields([])
    fnHandleCancel()
  }
  const [bOpenToolTip, fnSetBOpenToolTip] = useState(false)

  function RcmpTooltip(props) {
    const { oUser } = props

    if (!oUser) return null

    function fnOpenToolTip() {
      fnSetBOpenToolTip(true)
    }

    function fnCloseToolTip() {
      fnSetBOpenToolTip(false)
    }

    return (
      <div
        className={styles.userIconContainer}
        onMouseEnter={fnOpenToolTip}
        onMouseLeave={fnCloseToolTip}
      >
        {bOpenToolTip && <div className={styles.floatContent}>{oUser?.user_cname}</div>}
      </div>
    )
  }

  function debounce(func, delay) {
    let timerId

    return function (...args) {
      clearTimeout(timerId)

      timerId = setTimeout(() => {
        func.apply(this, args)
      }, delay)
    }
  }

  function unificarArrays(a, b) {
    // Cria um objeto para armazenar os itens unificados
    const unificados = {};

    // Adiciona os itens da primeira array
    a.forEach(({ item, value }) => {
        unificados[item] = value;
    });

    // Adiciona ou atualiza os itens da segunda array
    b.forEach(({ item, value }) => {
        unificados[item] = value;
    });

    // Converte o objeto de volta para um array
    return Object.keys(unificados).map(item => ({
        item: Number(item),
        value: unificados[item]
    }));
}

  const debouncedHandleChange = debounce((value) => {
    const unfilteredData = formatFieldsByType()
     if(value === "") {
      //Verifica os valores que estão marcados como visiveis e seta no estado
      return fnSetAFieldsByType(aFieldsByTypeCopy)
     }
     
      const filteredData = aFieldsByTypeCopy.map((oFieldByType) => {
        const aFields = oFieldByType?.aFields?.filter((oField) => {
          return oField?.opfd_cname?.toLowerCase().includes(value.toLowerCase())
        })
        
        return {
          ...oFieldByType,
          aFields,
        }
      })
      fnSetAFieldsByType(filteredData.filter(oFieldsByType => oFieldsByType.aFields.length > 0))
    }, 500)

    function fnSearchTerm(value) {
      fnSetCTermFilter(value)
      debouncedHandleChange(value)
    }
  function fnResetSearch() {
    debouncedHandleChange("")
    fnSetCTermFilter("")
    return fnSetAFieldsByType(aFieldsByTypeCopy)
  }
  function elEditFieldButton(field) {
    function handleOpenFieldModal() {
      fnEditCustomField(field)
    }

    return (
      <PencilIcon className={styles.editFieldButton} onClick={handleOpenFieldModal} />
    )
  }
  return (
    <RcmpModalAdd
      isOpen={bIsOpen}
      buttonCancelText={buttonCancelText}
      buttonSaveText={buttonSaveText}
      title={title}
      fnHandleCancel={fnHandleStateAndCancel}
      fnHandleConfirm={fnHandleConfirmUpdateVisibilityFields}
      buttonType={"button"}
      size={size}
      oButtonSaveProps={{ isLoading: bSaveLoading }}
      oButtonCancelProps={{ disabled: bSaveLoading }}
      disabledSaveButton={aCheckedFieldsList?.length === 0}
    >
      <div className={styles.modalInfoContent}>
        <div className={styles.textHeadModalCustomFields}>
          <Input
            width="100%"
            className={styles.inputSearch}
            isSearch
            placeholder={"Pesquisar campos"}
            onChange={(ev) => {
              fnSearchTerm(ev.target.value)
            }}
            fnResetSearch={fnResetSearch}
            value={cTermFilter}
          />
          <Typography color="#415364" type="l3" textAlign="left">
            {textHead}
          </Typography>
          <span
            style={{
              width: "fit-content",
              color: "#08507B",
              backgroundColor: "#DCEBF4",
              padding: "8px 16px",
              borderRadius: "500px",
              fontSize: "12px",
              fontStyle: "italic",
              display: "flex",
              gap: "4px",
              alignItems: "center",
            }}
          >
            Campos marcados com <InfoIcon width={12} height={12} /> são campos que foram
            importados de um quadro modelo.
          </span>
        </div>
        {oAllFieldsRes?.loading ? (
          <div className={styles.loadingContainer}>
            <RcmpLoading bShow={true} />
          </div>
        ) : (
          <>
            {aFieldsByType?.map((oFieldType, index) => {
              return (
                <RcmpSingleAccordionIcon
                  oGetData={{
                    acbl_cname: oFieldType.cFieldType.label,
                    id: `accordion-id${index}`,
                  }}
                  icon={
                    <RcmpActivityIcon
                      fill={"#415364"}
                      cType={oFieldType.cFieldType.value}
                    />
                  }
                  key={index}
                >
                  <div className={styles.contentAccordion} ref={parentRef}>
                    {oFieldType?.aFields?.map((field, index) => {
                      const isChecked = aCheckedFieldsList?.some(
                        (checked) =>
                          checked.opfd_nid === field.opfd_nid &&
                          checked?.opvf_bis_visible,
                      )
                      const bSlugIsEqual =
                        field.opfd_cslug === cDeadLineSlug ||
                        field.opfd_ctype === "PEOPLES" ||
                        field.opfd_cslug === dCreationDateSlug ||
                        field.opfd_cslug === dConclusionDateSlug ||
                        field.opfd_cslug === cStatusSlug ||
                        field.opfd_ctype === "CALC"
                      const bIsDisabled = bNewFormCriation && bSlugIsEqual
                      return (
                        <RcmpCheckBox
                          cdescription={field.opfd_cdescription}
                          key={index}
                          cLabel={`${field.opfd_cname}`}
                          bCanShowTooltip={field.opfd_cslug === dConclusionDateSlug}
                          checked={
                            !bIsDisabled
                              ? isChecked
                              : field?.opfd_cslug === cStatusSlug && bIsVisibleFieldsTable
                          }
                          onChange={() => fnHandleCheckbox(index, oFieldType)}
                          disabled={
                            (field?.opfd_cslug === cStatusSlug &&
                              !bIsVisibleFieldsTable) ||
                            bIsDisabled
                              ? true
                              : false
                          }
                          className={styles.checkboxField}
                          isExportedField={
                            field.opfd_bcreated_by_operational_panel_board_model
                          }
                          parentRef={parentRef}
                          boardModel={field.operational_panel_board_model}
                          HoverActionButton={
                            !oCurrentBoard?.bIsResponsible || !field?.opfd_bis_default
                              ? () => elEditFieldButton(field)
                              : null
                          }
                        />
                      )
                    })}
                  </div>
                </RcmpSingleAccordionIcon>
              )
            })}
            {aFieldsByType?.length === 0 && (
              <p style={{ color: "#415364", alignSelf: "flex-start" }}>
                Nenhum campo foi encontrado...
              </p>
            )}
          </>
        )}
      </div>
      {bAddNewFields && (
        <div className={styles.newCustomField} onClick={fnOpenModalNewCustomField}>
          <PurePlusIcon fill={"#6CB6E3"} width={"16"} height={"16"} />
          <p>{intl.get("BlocksPage.create_field")}</p>
        </div>
      )}
    </RcmpModalAdd>
  )
}
